module.exports = __webpack_public_path__ + "static/media/puzzle0902.809eed71.png";